export enum DiamondBaseColor {
  orange,
  green,
  red,
  blue,
  gray,
  gold,
}

export enum DiamondBasePosition {
  up,
  middle,
  down,
}
